export const languageSet = (language) => {
    return {
        type: "LANGUAGE_SET",
        payload: language
    }
};